import httpClient from '@common/api/httpClient';
import paramsSerializer from '@common/api/paramsSerializer';
import {
  type CreateDebugSessionDetails,
  type DebugSessionResponse,
  type DebugSessionWithRulesResponse,
  type PaginatedItemsResponse,
} from '@common/types/api';
import { type GUID } from '@common/types/brandedTypes';
import { formatAsUtcTimestamp } from '@common/utils/datetime/isoTimestamp';
import { type ListWithCount } from '@common/utils/formatting/paginationQueryHelpers';

export async function fetchDebugSessions(
  deviceId: number,
  take: number,
  skip: number,
): Promise<ListWithCount<DebugSessionResponse>> {
  const { data } = await httpClient.get<PaginatedItemsResponse<DebugSessionResponse>>(
    '/rest/v2/DebugSessions',
    {
      params: {
        deviceIds: [deviceId],
        skip,
        take,
      },
      paramsSerializer,
    },
  );
  return {
    items: data.items,
    count: data.totalCount,
  };
}

export async function fetchDebugSessionDetails(
  id: GUID,
) {
  const { data } = await httpClient.get<DebugSessionWithRulesResponse>(
    `/rest/v1/DebugSessions/${id}`,
  );
  return data;
}

export async function stopDebugSession(
  id: GUID,
) {
  return httpClient.post(`/rest/v1/DebugSessions/${id}/stop`);
}

export async function downloadDebugSession(
  id: GUID,
) {
  const { data } = await httpClient.get<string>(`/rest/v1/DebugSessions/${id}/download`);
  return data;
}

export async function createDebugSession(
  deviceId: number,
  debugSession: CreateDebugSessionDetails,
) {
  await httpClient.post('/rest/v1/DebugSessions', {
    deviceId,
    rules: {
      startUtc: debugSession.startUtc ?? formatAsUtcTimestamp(new Date()),
      ...debugSession,
    },
  });
}
